import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { LayoutDefaultComponent } from '../common/components/layout-default/layout-default.component';
import { UserAuthGuard } from '../user/guards/user-auth-guard';
import { PermissionGuard } from '../../core/guards/permission.guard';



@NgModule({
  providers: [
    provideRouter([
      {
        path: 'reports',
        component: LayoutDefaultComponent,
        canActivate: [UserAuthGuard, PermissionGuard],
        data: { permissions: 'GET_REPORTS' },
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/reports/reports.component'),
          },
          {
            // The target of a notification's click-to-view link. Inherits the
            // parent's UserAuthGuard, so a logged-out click lands on login and
            // returns here afterwards.
            path: ':reportId',
            loadComponent: () => import('./pages/report-viewer/report-viewer.component'),
          }
        ]
      },
    ], withComponentInputBinding()),
  ]
})
export class ReportsRoutingModule { }
